import { Mail01 } from "@untitledui/icons/Mail01";
import { useDispatch, useSelector } from "react-redux";
import TextButton from "../../components/Buttons/textButton";
import Button from "../../components/Buttons/button";
import { closeModal } from "../../redux/modal.slice";

const CheckEmailSignupModal = () => {
  const modalEmail = useSelector((state) => state.modal.modalData);
  const dispatch = useDispatch();

  const closePopup = () => {
    dispatch(closeModal({}));
  };

  return (
    <>
      <div className="modal-header text-center">
        <div className="icon purple">
          <Mail01 />
        </div>
        <h4 className="mb-8">Please check your email.</h4>
        <p className="text-color-grey">
          We've sent a verification link to <span>{modalEmail?.email}</span>.
        </p>
      </div>
      <div className="modal-body text-center">
        <p className="have-account-question medium-text text-color-grey-700 mb-32">
          Didn’t receive the email?
          <TextButton
            text={"Click to resend"}
            className={"ml-8"}
          />
        </p>
        <Button
          text={"Got It"}
          type={"outline"}
          fullWidth={true}
          onClick={closePopup}
        />
      </div>
    </>
  );
};

export default CheckEmailSignupModal;
